import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    money: [
//         {
//             cash: 10000,
//             storageLocation: '自宅',
//             targetPerson: 'テスト相続人1',
//             inheritanceBequest: '相続'
//         },
//         {
//             cash: 20000,
//             storageLocation: '会社',
//             targetPerson: 'テスト相続人2',
//             inheritanceBequest: '相続'
//         },
//         {
//             cash: 30000,
//             storageLocation: '別荘',
//             targetPerson: 'テスト相続人3',
//             inheritanceBequest: '相続'
//         }
    ]
};

const slice = createSlice({
    name: 'money',
    initialState,
    reducers: {
        setMoney: (state, action) => {
            return Object.assign({}, state, { money: state.money.concat(action.payload) })
        },
        clearMoney: (state, action) => {
            const newArray = Array.from(new Set([...state.money]));
            newArray.splice(action.payload, 1)
            return Object.assign({}, state, { money: newArray })
        },
    }
});


export default slice.reducer;

export const {
    setMoney,
    clearMoney,
} = slice.actions;
